import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { INSERT_ATTACHMENT_COMMAND } from './AttachmentPlugin';
import {
  isFhirReference,
  isFhirResource,
  ReferenceOrResource,
} from '../../../../AttachmentArbiter/Attachment';

export const useInsertAttachment = () => {
  const [editor] = useLexicalComposerContext();

  return useCallback(
    (attachment: ReferenceOrResource, index: number) => {
      const reference = isFhirReference(attachment)
        ? (attachment.identifier?.value as string)
        : isFhirResource(attachment)
        ? (attachment.id as string)
        : undefined;
      if (!reference) {
        console.error('Attachment not a reference or resource', attachment);
        return;
      }
      editor.dispatchCommand(INSERT_ATTACHMENT_COMMAND, {
        id: index.toString(),
        reference,
      });
    },
    [editor],
  );
};
